import React, { Component } from 'react';

class Popup extends Component {
	render() {
		return (
			<div className="full__ingredients">
					<div className="full__ingredients--modal">
					<span className="cross_popup"><img src="/images/assessment/cross-icon.svg" /></span>
					<div className="row">
						<div className="col-md-6">
							<div className="full__ingredients-content">
								<h1>Clean Slate Exfoliating Pads</h1>
								<div className="full__ingredients-content-icons row">
									<div className="col-3">
										<img src="/images/assessment/ing-1.svg" />
									</div>
									<div className="col-3">
										<img src="/images/assessment/ing-2.svg" />
									</div>
									<div className="col-3">
										<img src="/images/assessment/ing-3.svg" />
									</div>
									<div className="col-3">
										<img src="/images/assessment/ing-4.svg" />
									</div>
								</div>
								<div className="d-none d-md-block">
									<h3>Clean, Safe, Effective</h3>
									<p>Each ingredient is carefully sourced through transparent supply chains, and rigoroulsy tested to ensure the highest standards of safety, quality and efficacy––rest assured you’re only getting the best for your skin!</p>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="full__ingredients-list">
								<ul>
									<li className="ingredients_heading">Full Ingredients List: <span className="float-right"><img src="/images/assessment/ewg.svg" /> EWG* Rating</span></li>
									<li>Aqua (Water) <span className="float-right green">1</span></li>
									<li>Glycerin <span className="float-right green">2</span></li>
									<li>Propylene Glycol <span className="float-right green">2</span></li>
									<li>Alcohol <span className="float-right green">1</span></li>
									<li>1,2-Hexanediol <span className="float-right yellow">1</span></li>
									<li>Phenoxyethanol <span className="float-right green">1</span></li>
									<li>Xanthan Gum <span className="float-right green">1</span></li>
									<li>Arginine <span className="float-right green">2</span></li>
									<li>Salicylic Acid <span className="float-right green">1</span></li>
									<li>Centella Asiatica Extract <span className="float-right red">2</span></li>
									<li>Disodium EDTA <span className="float-right green">2</span></li>
									<li>Butylene Glycol <span className="float-right green">2</span></li>
									<li>Anthemis Nobilis Flower Extract <span className="float-right green">2</span></li>
									<li>Sodium Hyaluronate <span className="float-right green">2</span></li>
									<li>Camellia Sinensis Leaf Extract <span className="float-right green">2</span></li>
									<li>Glycerin <span className="float-right green">2</span></li>
									<li>Propylene Glycol <span className="float-right green">2</span></li>
									<li>Alcohol <span className="float-right green">1</span></li>
									<li>1,2-Hexanediol <span className="float-right green">1</span></li>
									<li>Phenoxyethanol <span className="float-right green">1</span></li>
									<li>Xanthan Gum <span className="float-right green">1</span></li>
									<li>Arginine <span className="float-right green">2</span></li>
									<li>Salicylic Acid <span className="float-right green">1</span></li>
									<li>Centella Asiatica Extract <span className="float-right green">2</span></li>
									<li>Disodium EDTA <span className="float-right green">2</span></li>
									<li>Butylene Glycol <span className="float-right green">2</span></li>
									<li>Anthemis Nobilis Flower Extract <span className="float-right green">2</span></li>
									<li>Sodium Hyaluronate <span className="float-right green">2</span></li>
									<li>Camellia Sinensis Leaf Extract <span className="float-right green">2</span></li>
								</ul>
							</div>
						</div>
					</div>
					<p className="ingredient_options">EWG* : Environmental Working Group <span className="green">1-2</span> : High safety | <span className="yellow">3-6</span> : Moderate safety | <span className="red">7-10</span>: Low safety N/A: Not yet rated</p>
					<div className="for__mobile d-block d-md-none">
						<h3>Clean, Safe, Effective</h3>
						<p>Each ingredient is carefully sourced through transparent supply chains, and rigoroulsy tested to ensure the highest standards of safety, quality and efficacy––rest assured you’re only getting the best for your skin!</p>
					</div>
				</div>
			</div>
		);
	}
}


export default Popup;